module.exports = __webpack_public_path__ + "static/media/img43.e8fb1721.jpg";